<template>
  <page-header
    :current="navCurrent"
    :progress="navProgress"
    :content-open="contentOpen"
    :content-title="contentTitle"
    :touch-pad="isTouchPad"
    :progress-opacity="progressOpacity"
    :mobile-scroll="mobileScroll"
    @close-content="closeContent"
  />
  <background-gradient />
  <horizontal-scroller
    :prevent-scroll="preventScroll"
    :content-open="contentOpen"
    :scroll-target="scrollTarget"
    @scroll-change="scrollHandler"
    @prevent-scroll="preventScrollChange"
    @is-touch-pad="setTouchPad"
    @scroll-to="scrollTargetHandler"
  />
  <div class="content-wrapper" :class="{'show-content': contentOpen}" ref="contentWrapper">
    <router-view v-slot="{ Component }">
      <transition name="change">
        <component :is="Component"
                   :key="$route.path"
                   @change-content="changeContent"
                   @scroll-to="scrollTargetHandler"
                   @scroll-to-top="scrollToTop"
                   @cover-change="coverChange"/>
      </transition>
    </router-view>
  </div>
  <div class="page-overlay" v-if="showOverlay" @click="closeOverlay">
    <div class="inner">
      <img src="./assets/logo.svg" alt="enercity Logo">
      <h1>Geschäftsbericht 2020</h1>
      <p>Coming soon</p>
    </div>
  </div>
</template>

<script>
import { gsap, Cubic } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import HorizontalScroller from "./components/HorizontalScroller";
import PageHeader from "./components/PageHeader";
import BackgroundGradient from "./elements/BackgroundGradient";

gsap.registerPlugin(ScrollToPlugin);

export default {
  components: {BackgroundGradient, PageHeader, HorizontalScroller},
  data() {
    return {
      navCurrent: 0,
      navProgress: 0,
      contentOpen: false,
      contentTitle: "",
      preventScroll: false,
      scrollTarget: '/',
      isTouchPad: false,
      progressOpacity: 1,
      mobileScroll: 0,
      showOverlay: false,
      history: []
    }
  },
  methods: {
    closeOverlay(e) {
      if (e.clientX < 20 && e.clientY && e.ctrlKey) {
        this.showOverlay = false;
      }
    },
    preventScrollChange(data) {
      console.log(data);
    },
    scrollToTop() {
      gsap.to(this.$refs.contentWrapper, {
        scrollTo: {x: 0, y: 0},
        duration: 1,
        ease: Cubic.easeInOut,
      })
    },
    scrollTargetHandler(data) {
      this.contentOpen = false;
      this.scrollTarget = data.target;
    },
    scrollHandler(e) {
      this.navCurrent = e.current;
      this.navProgress = e.progress;
    },
    changeContent(data) {
      this.contentOpen = data.showContent;
      this.contentTitle = data.title;
      this.progressOpacity = 1;
      if (this.contentOpen) {
        this.preventScroll = true;
      }
    },
    closeContent() {
      this.contentOpen = false;
      this.preventScroll = false;
      this.progressOpacity = 1;
      if (this.history.length < 2) {
        this.$router.push('/');
      }
      else {
        this.$router.go(-1);
      }
    },
    setTouchPad() {
      this.isTouchPad = true;
    },
    coverChange(data) {
      this.progressOpacity = data.progressOpacity;
    },
    handleMobileScroll() {
      this.mobileScroll = Math.round(window.scrollY / (document.body.scrollHeight - window.innerHeight) * 1000) / 1000;
    }
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || 'enercity Geschäftsbericht 2020';
      this.history.push(from);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleMobileScroll);
  }
}
</script>

<style>
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-Regular-WebS.svg") format("svg");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-RegularItalic-WebS.svg") format("svg");
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-Medium-WebS.svg") format("svg");
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-MediumItalic-WebS.svg") format("svg");
    font-weight: 500;
    font-style: italic;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-Light-WebS.svg") format("svg");
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-LightItalic-WebS.svg") format("svg");
    font-weight: 300;
    font-style: italic;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-Bold-WebS.svg") format("svg");
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: "Euclid";
    src: url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.eot");
    src: url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.woff2") format("woff2"), url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.woff") format("woff"), url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.ttf") format("truetype"), url("./assets/fonts/euclid/EuclidEnercity-BoldItalic-WebS.svg") format("svg");
    font-weight: 700;
    font-style: italic;
  }
  @font-face {
    font-family: 'Icons';
    src: url('./assets/fonts/icons/icons.eot?1235807');
    src: url('./assets/fonts/icons/icons.eot?1235807#iefix') format('embedded-opentype'), url('./assets/fonts/icons/icons.woff2?1235807') format('woff2'), url('./assets/fonts/icons/icons.woff?1235807') format('woff'), url('./assets/fonts/icons/icons.ttf?1235807') format('truetype'), url('./assets/fonts/icons/icons.svg?1235807#icons') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  .icon-arrow:before { content: '\e800'; }
  .icon-arrow-link:before { content: '\e801'; }
  .icon-fb:before { content: '\e802'; }
  .icon-left:before { content: '\e803'; }
  .icon-right:before { content: '\e804'; }
  .icon-twitter:before { content: '\e805'; }
  .icon-xing:before { content: '\e807'; }
  html, body {
    margin: 0;
    padding: 0;
    font-family: "Euclid", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
    color: #102D61;
  }
  *, *:before, *:after {
    box-sizing: border-box;
  }
  h2 {
    font-size: 36px;
    line-height: 1.2;
    margin: 0.5em -0.05em;
    font-weight: 700;
  }
  p {
    margin: 1em 0;
  }
  .content-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    transform: translate3d(0, 100%, 0);
    transition: 0.6s cubic-bezier(0.33, 1, 0.68, 1);
    box-shadow: 0 0 0 3000px rgba(16, 45, 97, 0);
  }
  .content-wrapper.show-content {
    transform: translate3d(0, 0, 0);
    //box-shadow: 0 0 0 3000px rgba(16, 45, 97, 0.5);
  }
  p a {
    color: #C7125C;
    transition: 0.2s ease;
  }
  p a:hover {
    color: #3ABABA;
  }
  .nowrap {
    white-space: nowrap;
  }
  article img {
    display: block;
    max-width: 100%;
  }
  figure {
    margin: 0;
  }
  figcaption, .figcaption {
    font-size: 14px;
    color: #9a989c;
    margin: 1em 0;
  }
  .change-enter, .change-leave-active {
    opacity: 0;
  }
  .change-enter-active, .change-leave-active {
    transition: opacity 0s ease 0.7s;
  }
  img, a, button {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
  }
  .page-overlay {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    z-index: 100;
    text-align: center;
  }
  .page-overlay img {
    width: 200px;
    position: absolute;
    top: 20px;
    left: 50%;
    margin-left: -100px;
  }
  .page-overlay h1 {
    font-size: 50px;
    margin: 0;
  }
  .page-overlay p {
    font-size: 24px;
    font-weight: 400;
    margin: 10px 0 50px;
  }
  a:focus, button:focus {
    outline: 0;
  }
  @media(min-width: 1000px) {
    html, body {
      overflow: hidden;
    }
  }
  @media(max-width: 1199px), (max-height: 799px) {
    html, body {
      font-size: 15px;
    }
    h2 {
      font-size: 24px;
    }
    figcaption {
      font-size: 12px;
    }
  }
  @media(max-width: 999px) {
    .content-wrapper {
      position: fixed;
      transform: translate3d(100%, 0, 0);
    }
  }
</style>